import { clearScopeInsiderCapability } from "@lib/api/scopeContext";

import { clearLogas } from "./clearLogas";

export function clearLogin() {
    // clear localStorage of login-related keys
    localStorage.removeItem("Meteor.loginToken");
    localStorage.removeItem("Meteor.userId");
    localStorage.removeItem("google_login");

    // also clear logas (user impersonation) data
    clearLogas();
    clearScopeInsiderCapability();
}
